(function () {
  var touchPositions = new WeakMap();

  function getSlides(carousel) {
    return Array.from(
      carousel.querySelectorAll('[data-qnk-slide]')
    );
  }

  function loadImage(slide) {
    if (!slide) return;

    var source = slide.getAttribute('data-src');
    var sourceSet = slide.getAttribute('data-srcset');

    if (sourceSet) {
      slide.setAttribute('srcset', sourceSet);
      slide.removeAttribute('data-srcset');
    }

    if (source) {
      slide.setAttribute('src', source);
      slide.removeAttribute('data-src');
    }
  }

  function showSlide(carousel, direction) {
    var slides = getSlides(carousel);

    if (slides.length < 2) return;

    var current = parseInt(
      carousel.getAttribute('data-current-slide') || '0',
      10
    );

    var next = current + direction;

    if (next < 0) {
      next = slides.length - 1;
    }

    if (next >= slides.length) {
      next = 0;
    }

    loadImage(slides[next]);

    slides.forEach(function (slide, index) {
      var active = index === next;

      slide.classList.toggle('is-active', active);
      slide.setAttribute(
        'aria-hidden',
        active ? 'false' : 'true'
      );
    });

    carousel.setAttribute(
      'data-current-slide',
      String(next)
    );
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener(
    'click',
    function (event) {
      var previousButton = event.target.closest(
        '[data-qnk-prev]'
      );

      var nextButton = event.target.closest(
        '[data-qnk-next]'
      );

      var button = previousButton || nextButton;

      if (!button) return;

      var carousel = button.closest(
        '[data-qnk-card-carousel]'
      );

      if (!carousel) return;

      /* En la portada ya funciona mediante su propio código */
      if (carousel.closest('.home-collection-tabs')) {
        return;
      }

      stopEvent(event);

      showSlide(
        carousel,
        previousButton ? -1 : 1
      );
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function (event) {
      var carousel = event.target.closest(
        '[data-qnk-card-carousel]'
      );

      if (!carousel) return;

      /* En la portada ya funciona mediante su propio código */
      if (carousel.closest('.home-collection-tabs')) {
        return;
      }

      var touch = event.changedTouches[0];

      touchPositions.set(carousel, {
        x: touch.clientX,
        y: touch.clientY
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (event) {
      var carousel = event.target.closest(
        '[data-qnk-card-carousel]'
      );

      if (!carousel) return;

      /* En la portada ya funciona mediante su propio código */
      if (carousel.closest('.home-collection-tabs')) {
        return;
      }

      var start = touchPositions.get(carousel);

      if (!start) return;

      var touch = event.changedTouches[0];
      var differenceX = touch.clientX - start.x;
      var differenceY = touch.clientY - start.y;

      touchPositions.delete(carousel);

      if (
        Math.abs(differenceX) >= 30 &&
        Math.abs(differenceX) > Math.abs(differenceY)
      ) {
        carousel.setAttribute(
          'data-qnk-block-click',
          'true'
        );

        showSlide(
          carousel,
          differenceX < 0 ? 1 : -1
        );
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      var carousel = event.target.closest(
        '[data-qnk-card-carousel]'
      );

      if (!carousel) return;

      if (
        carousel.getAttribute('data-qnk-block-click') ===
        'true'
      ) {
        stopEvent(event);
        carousel.removeAttribute('data-qnk-block-click');
      }
    },
    true
  );
})();